import { render, staticRenderFns } from "./SuitShimmer.vue?vue&type=template&id=ed49c646&"
import script from "./SuitShimmer.vue?vue&type=script&lang=js&"
export * from "./SuitShimmer.vue?vue&type=script&lang=js&"
import style0 from "./SuitShimmer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports